import * as React from "react";
const SvgChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 9, height: 5, viewBox: "0 0 9 5", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.5 1L4.5 4.5L8.5 1", stroke: "#404040", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgChevronDown;
